/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiInputAxis {
}

export enum UiInputAxis_Enum {
  UP = 0,
  RIGHT = 1,
  FORWARD = 2,
  YAW = 3,
  PITCH = 4,
  YAW_BUTTONS = 32,
  STRAFE_BUTTONS = 33,
  AZIMUTH_BUTTONS = 34,
  HEIGHT_SLIDER = 11,
  RANGE_SLIDER = 12,
  HEIGHT_BUTTONS = 35,
  RANGE_BUTTONS = 36,
  STEERING_STICK_X = 37,
  STEERING_STICK_Y = 38,
  STRAFING_STICK_X = 39,
  STRAFING_STICK_Y = 40,
  LEFT_TRIGGER = 5,
  RIGHT_TRIGGER = 6,
  LEFT_STICK_X = 7,
  LEFT_STICK_Y = 8,
  RIGHT_STICK_X = 9,
  RIGHT_STICK_Y = 10,
  START_BUTTON = 13,
  STOP_BUTTON = 14,
  PLUS_BUTTON = 15,
  MINUS_BUTTON = 16,
  A_BUTTON = 17,
  B_BUTTON = 18,
  C_BUTTON = 19,
  X_BUTTON = 24,
  Y_BUTTON = 25,
  Z_BUTTON = 26,
  HOME_BUTTON = 27,
  MENU_BUTTON = 28,
  MAGIC_BUTTON = 29,
  LEFT_SHOULDER = 30,
  RIGHT_SHOULDER = 31,
  LEFT_ARROW = 20,
  RIGHT_ARROW = 21,
  UP_ARROW = 22,
  DOWN_ARROW = 23,
  SNSR_SLEW = 41,
  LEFT_SHIFTER = 42,
  RIGHT_SHIFTER = 43,
  CUSTOM_1 = 44,
  CUSTOM_2 = 45,
  CUSTOM_3 = 46,
  ACTION_WHEEL_1 = 47,
  ACTION_WHEEL_2 = 48,
  ACTION_WHEEL_3 = 49,
  UNRECOGNIZED = -1,
}

export function uiInputAxis_EnumFromJSON(object: any): UiInputAxis_Enum {
  switch (object) {
    case 0:
    case "UP":
      return UiInputAxis_Enum.UP;
    case 1:
    case "RIGHT":
      return UiInputAxis_Enum.RIGHT;
    case 2:
    case "FORWARD":
      return UiInputAxis_Enum.FORWARD;
    case 3:
    case "YAW":
      return UiInputAxis_Enum.YAW;
    case 4:
    case "PITCH":
      return UiInputAxis_Enum.PITCH;
    case 32:
    case "YAW_BUTTONS":
      return UiInputAxis_Enum.YAW_BUTTONS;
    case 33:
    case "STRAFE_BUTTONS":
      return UiInputAxis_Enum.STRAFE_BUTTONS;
    case 34:
    case "AZIMUTH_BUTTONS":
      return UiInputAxis_Enum.AZIMUTH_BUTTONS;
    case 11:
    case "HEIGHT_SLIDER":
      return UiInputAxis_Enum.HEIGHT_SLIDER;
    case 12:
    case "RANGE_SLIDER":
      return UiInputAxis_Enum.RANGE_SLIDER;
    case 35:
    case "HEIGHT_BUTTONS":
      return UiInputAxis_Enum.HEIGHT_BUTTONS;
    case 36:
    case "RANGE_BUTTONS":
      return UiInputAxis_Enum.RANGE_BUTTONS;
    case 37:
    case "STEERING_STICK_X":
      return UiInputAxis_Enum.STEERING_STICK_X;
    case 38:
    case "STEERING_STICK_Y":
      return UiInputAxis_Enum.STEERING_STICK_Y;
    case 39:
    case "STRAFING_STICK_X":
      return UiInputAxis_Enum.STRAFING_STICK_X;
    case 40:
    case "STRAFING_STICK_Y":
      return UiInputAxis_Enum.STRAFING_STICK_Y;
    case 5:
    case "LEFT_TRIGGER":
      return UiInputAxis_Enum.LEFT_TRIGGER;
    case 6:
    case "RIGHT_TRIGGER":
      return UiInputAxis_Enum.RIGHT_TRIGGER;
    case 7:
    case "LEFT_STICK_X":
      return UiInputAxis_Enum.LEFT_STICK_X;
    case 8:
    case "LEFT_STICK_Y":
      return UiInputAxis_Enum.LEFT_STICK_Y;
    case 9:
    case "RIGHT_STICK_X":
      return UiInputAxis_Enum.RIGHT_STICK_X;
    case 10:
    case "RIGHT_STICK_Y":
      return UiInputAxis_Enum.RIGHT_STICK_Y;
    case 13:
    case "START_BUTTON":
      return UiInputAxis_Enum.START_BUTTON;
    case 14:
    case "STOP_BUTTON":
      return UiInputAxis_Enum.STOP_BUTTON;
    case 15:
    case "PLUS_BUTTON":
      return UiInputAxis_Enum.PLUS_BUTTON;
    case 16:
    case "MINUS_BUTTON":
      return UiInputAxis_Enum.MINUS_BUTTON;
    case 17:
    case "A_BUTTON":
      return UiInputAxis_Enum.A_BUTTON;
    case 18:
    case "B_BUTTON":
      return UiInputAxis_Enum.B_BUTTON;
    case 19:
    case "C_BUTTON":
      return UiInputAxis_Enum.C_BUTTON;
    case 24:
    case "X_BUTTON":
      return UiInputAxis_Enum.X_BUTTON;
    case 25:
    case "Y_BUTTON":
      return UiInputAxis_Enum.Y_BUTTON;
    case 26:
    case "Z_BUTTON":
      return UiInputAxis_Enum.Z_BUTTON;
    case 27:
    case "HOME_BUTTON":
      return UiInputAxis_Enum.HOME_BUTTON;
    case 28:
    case "MENU_BUTTON":
      return UiInputAxis_Enum.MENU_BUTTON;
    case 29:
    case "MAGIC_BUTTON":
      return UiInputAxis_Enum.MAGIC_BUTTON;
    case 30:
    case "LEFT_SHOULDER":
      return UiInputAxis_Enum.LEFT_SHOULDER;
    case 31:
    case "RIGHT_SHOULDER":
      return UiInputAxis_Enum.RIGHT_SHOULDER;
    case 20:
    case "LEFT_ARROW":
      return UiInputAxis_Enum.LEFT_ARROW;
    case 21:
    case "RIGHT_ARROW":
      return UiInputAxis_Enum.RIGHT_ARROW;
    case 22:
    case "UP_ARROW":
      return UiInputAxis_Enum.UP_ARROW;
    case 23:
    case "DOWN_ARROW":
      return UiInputAxis_Enum.DOWN_ARROW;
    case 41:
    case "SNSR_SLEW":
      return UiInputAxis_Enum.SNSR_SLEW;
    case 42:
    case "LEFT_SHIFTER":
      return UiInputAxis_Enum.LEFT_SHIFTER;
    case 43:
    case "RIGHT_SHIFTER":
      return UiInputAxis_Enum.RIGHT_SHIFTER;
    case 44:
    case "CUSTOM_1":
      return UiInputAxis_Enum.CUSTOM_1;
    case 45:
    case "CUSTOM_2":
      return UiInputAxis_Enum.CUSTOM_2;
    case 46:
    case "CUSTOM_3":
      return UiInputAxis_Enum.CUSTOM_3;
    case 47:
    case "ACTION_WHEEL_1":
      return UiInputAxis_Enum.ACTION_WHEEL_1;
    case 48:
    case "ACTION_WHEEL_2":
      return UiInputAxis_Enum.ACTION_WHEEL_2;
    case 49:
    case "ACTION_WHEEL_3":
      return UiInputAxis_Enum.ACTION_WHEEL_3;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UiInputAxis_Enum.UNRECOGNIZED;
  }
}

export function uiInputAxis_EnumToJSON(object: UiInputAxis_Enum): string {
  switch (object) {
    case UiInputAxis_Enum.UP:
      return "UP";
    case UiInputAxis_Enum.RIGHT:
      return "RIGHT";
    case UiInputAxis_Enum.FORWARD:
      return "FORWARD";
    case UiInputAxis_Enum.YAW:
      return "YAW";
    case UiInputAxis_Enum.PITCH:
      return "PITCH";
    case UiInputAxis_Enum.YAW_BUTTONS:
      return "YAW_BUTTONS";
    case UiInputAxis_Enum.STRAFE_BUTTONS:
      return "STRAFE_BUTTONS";
    case UiInputAxis_Enum.AZIMUTH_BUTTONS:
      return "AZIMUTH_BUTTONS";
    case UiInputAxis_Enum.HEIGHT_SLIDER:
      return "HEIGHT_SLIDER";
    case UiInputAxis_Enum.RANGE_SLIDER:
      return "RANGE_SLIDER";
    case UiInputAxis_Enum.HEIGHT_BUTTONS:
      return "HEIGHT_BUTTONS";
    case UiInputAxis_Enum.RANGE_BUTTONS:
      return "RANGE_BUTTONS";
    case UiInputAxis_Enum.STEERING_STICK_X:
      return "STEERING_STICK_X";
    case UiInputAxis_Enum.STEERING_STICK_Y:
      return "STEERING_STICK_Y";
    case UiInputAxis_Enum.STRAFING_STICK_X:
      return "STRAFING_STICK_X";
    case UiInputAxis_Enum.STRAFING_STICK_Y:
      return "STRAFING_STICK_Y";
    case UiInputAxis_Enum.LEFT_TRIGGER:
      return "LEFT_TRIGGER";
    case UiInputAxis_Enum.RIGHT_TRIGGER:
      return "RIGHT_TRIGGER";
    case UiInputAxis_Enum.LEFT_STICK_X:
      return "LEFT_STICK_X";
    case UiInputAxis_Enum.LEFT_STICK_Y:
      return "LEFT_STICK_Y";
    case UiInputAxis_Enum.RIGHT_STICK_X:
      return "RIGHT_STICK_X";
    case UiInputAxis_Enum.RIGHT_STICK_Y:
      return "RIGHT_STICK_Y";
    case UiInputAxis_Enum.START_BUTTON:
      return "START_BUTTON";
    case UiInputAxis_Enum.STOP_BUTTON:
      return "STOP_BUTTON";
    case UiInputAxis_Enum.PLUS_BUTTON:
      return "PLUS_BUTTON";
    case UiInputAxis_Enum.MINUS_BUTTON:
      return "MINUS_BUTTON";
    case UiInputAxis_Enum.A_BUTTON:
      return "A_BUTTON";
    case UiInputAxis_Enum.B_BUTTON:
      return "B_BUTTON";
    case UiInputAxis_Enum.C_BUTTON:
      return "C_BUTTON";
    case UiInputAxis_Enum.X_BUTTON:
      return "X_BUTTON";
    case UiInputAxis_Enum.Y_BUTTON:
      return "Y_BUTTON";
    case UiInputAxis_Enum.Z_BUTTON:
      return "Z_BUTTON";
    case UiInputAxis_Enum.HOME_BUTTON:
      return "HOME_BUTTON";
    case UiInputAxis_Enum.MENU_BUTTON:
      return "MENU_BUTTON";
    case UiInputAxis_Enum.MAGIC_BUTTON:
      return "MAGIC_BUTTON";
    case UiInputAxis_Enum.LEFT_SHOULDER:
      return "LEFT_SHOULDER";
    case UiInputAxis_Enum.RIGHT_SHOULDER:
      return "RIGHT_SHOULDER";
    case UiInputAxis_Enum.LEFT_ARROW:
      return "LEFT_ARROW";
    case UiInputAxis_Enum.RIGHT_ARROW:
      return "RIGHT_ARROW";
    case UiInputAxis_Enum.UP_ARROW:
      return "UP_ARROW";
    case UiInputAxis_Enum.DOWN_ARROW:
      return "DOWN_ARROW";
    case UiInputAxis_Enum.SNSR_SLEW:
      return "SNSR_SLEW";
    case UiInputAxis_Enum.LEFT_SHIFTER:
      return "LEFT_SHIFTER";
    case UiInputAxis_Enum.RIGHT_SHIFTER:
      return "RIGHT_SHIFTER";
    case UiInputAxis_Enum.CUSTOM_1:
      return "CUSTOM_1";
    case UiInputAxis_Enum.CUSTOM_2:
      return "CUSTOM_2";
    case UiInputAxis_Enum.CUSTOM_3:
      return "CUSTOM_3";
    case UiInputAxis_Enum.ACTION_WHEEL_1:
      return "ACTION_WHEEL_1";
    case UiInputAxis_Enum.ACTION_WHEEL_2:
      return "ACTION_WHEEL_2";
    case UiInputAxis_Enum.ACTION_WHEEL_3:
      return "ACTION_WHEEL_3";
    case UiInputAxis_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseUiInputAxis(): UiInputAxis {
  return {};
}

export const UiInputAxis = {
  encode(_: UiInputAxis, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiInputAxis {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiInputAxis();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UiInputAxis {
    return {};
  },

  toJSON(_: UiInputAxis): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UiInputAxis>, I>>(base?: I): UiInputAxis {
    return UiInputAxis.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiInputAxis>, I>>(_: I): UiInputAxis {
    const message = createBaseUiInputAxis();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
